/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vault_Access_DeniedInputs */

const en_vault_access_denied = /** @type {(inputs: Vault_Access_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault Access Denied`)
};

const es_vault_access_denied = /** @type {(inputs: Vault_Access_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso a la bóveda denegado`)
};

const fr_vault_access_denied = /** @type {(inputs: Vault_Access_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès au coffre-fort refusé`)
};

const de_vault_access_denied = /** @type {(inputs: Vault_Access_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugang zum Vault verweigert`)
};

const ja_vault_access_denied = /** @type {(inputs: Vault_Access_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保管庫へのアクセスが拒否されました`)
};

const zh_vault_access_denied = /** @type {(inputs: Vault_Access_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`金库访问被拒绝`)
};

const ar_vault_access_denied = /** @type {(inputs: Vault_Access_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم رفض الوصول إلى الخزنة`)
};

const id_vault_access_denied = /** @type {(inputs: Vault_Access_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses Vault Ditolak`)
};

const it_vault_access_denied = /** @type {(inputs: Vault_Access_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesso al Vault Negato`)
};

const ru_vault_access_denied = /** @type {(inputs: Vault_Access_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступ в Хранилище закрыт`)
};

const pt_vault_access_denied = /** @type {(inputs: Vault_Access_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesso ao Cofre Negado`)
};

const ko_vault_access_denied = /** @type {(inputs: Vault_Access_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보관소(Vault) 접근 거부됨`)
};

/**
* | output |
* | --- |
* | "Vault Access Denied" |
*
* @param {Vault_Access_DeniedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const vault_access_denied = /** @type {((inputs?: Vault_Access_DeniedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vault_Access_DeniedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vault_access_denied(inputs)
	if (locale === "es") return es_vault_access_denied(inputs)
	if (locale === "fr") return fr_vault_access_denied(inputs)
	if (locale === "de") return de_vault_access_denied(inputs)
	if (locale === "ja") return ja_vault_access_denied(inputs)
	if (locale === "zh") return zh_vault_access_denied(inputs)
	if (locale === "ar") return ar_vault_access_denied(inputs)
	if (locale === "id") return id_vault_access_denied(inputs)
	if (locale === "it") return it_vault_access_denied(inputs)
	if (locale === "ru") return ru_vault_access_denied(inputs)
	if (locale === "pt") return pt_vault_access_denied(inputs)
	return ko_vault_access_denied(inputs)
});